import { FC, useRef } from 'react';

import { CSSTransition } from 'react-transition-group';
import { Alert as ReactAlert } from 'reactstrap';

import { AlertProps } from 'types/components/alerts';

import { Errors } from './components';

import './alert.component.scss';

const Alert: FC<AlertProps> = ({ children, error, show = true, type = 'info' }) => {
  const alertRef = useRef<HTMLDivElement | null>(null);
  let component = (
    <ReactAlert
      color="info"
      innerRef={alertRef}>
      {children}
    </ReactAlert>
  );

  switch (type) {
    case 'error':
      component = (
        <Errors
          error={error}
          ref={alertRef}>
          {children}
        </Errors>
      );
      break;

    case 'success':
      component = (
        <ReactAlert
          color="success"
          innerRef={alertRef}>
          {children}
        </ReactAlert>
      );
      break;

    case 'warning':
      component = (
        <ReactAlert
          color="warning"
          innerRef={alertRef}>
          {children}
        </ReactAlert>
      );
      break;
  }

  return (
    <div className="alert-wrapper">
      <CSSTransition
        classNames=""
        in={show}
        mountOnEnter
        nodeRef={alertRef}
        timeout={300}
        unmountOnExit>
        {component}
      </CSSTransition>
    </div>
  );
};

export default Alert;
